<template>
  <div>
    <vx-card no-shadow>
      <div class="flex items-center justify-between">
        <h3 class="mb-0">Billing</h3>
        <div class="space-x-2">
          <a-dropdown-button v-if="hasPermission('billing.create')" type="primary" @click="addQuickBill" style="border-radius: 3px !important;">
            New bills
            <a-menu slot="overlay">
              <a-menu-item v-if="hasPermission('billing.fund-request.create')" key="1" @click="open_fund_client = true">New Trust Fund Request</a-menu-item>
              <a-menu-item key="2" @click="newReceipt">New Official Receipt</a-menu-item>
            </a-menu>
            <a-icon slot="icon" type="down" />
          </a-dropdown-button>
        </div>
      </div>
      <a-divider />
      <a-tabs v-model="tab_bill" default-active-key="1" @change="tabClick">
        <a-button slot="tabBarExtraContent" type="primary" ghost @click="showDrawer" style="border-radius: 3px !important;">
         Filters and Export
        </a-button>
        <a-tab-pane key="1" tab="All Invoices" force-render>
          <a-form-item has-feedback>
            <a-select
              style="width: 300px"
              allowClear
              class="select my-5"
              placeholder="Status Bill"
              show-search
              :filter-option="filterOption"
              @change="handleChangeFilterStatus"
            >
              <a-select-option :value="2">
                Approved
              </a-select-option>
              <a-select-option :value="4">
                Paid
              </a-select-option>
            </a-select>
          </a-form-item>
          <XTable class="overflow-auto"
                  ref="bill"
                  :model="model"
                  @clickRow="clickRow"
                  :options="{ placeholder:'Search bill',noContent: 'No bill',is_row_selection: false,is_load_req: false,temp_row: null }"
          >
            <span slot="bill_id" slot-scope="text,record">
              <a-button type="link" @click="dashboardId(text.record.id)">{{ text.record.factor_no }}</a-button>
            </span>
            <span slot="type" slot-scope="text,record">
              <template v-if="text.record.type === 1">
                Billing
              </template>
              <template v-if="text.record.type === 2">
                Funds Request
              </template>
            </span>
            <span slot="issue_date" slot-scope="text,record">
              {{ setDateFormat(text.record.issue_date) }}
            </span>
            <span slot="due_date" slot-scope="text,record">
              {{ setDateFormat(text.record.due_date) }}
            </span>
            <span slot="contact" slot-scope="text,record" v-if="text.record.to_contact">
                <template v-if="text.record.to_contact.person">
                   {{ text.record.to_contact.person.first_name }} {{ text.record.to_contact.person.last_name }}
                </template>
                <template v-else>
                   {{ text.record.to_contact.company.name }}
                </template>
            </span>
            <span slot="matter" slot-scope="text,record,index" class="flex flex-row">
              <div v-for="matter in text.record.matters">
                <a-popover>
                  <template slot="content">
                    <p>{{ matter.title }}</p>
                  </template>
                  <a-tag style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; max-width: 8rem;">
                    {{ matter.title }}
                  </a-tag>
                </a-popover>
              </div>
            </span>
            <span slot="level" slot-scope="text,record">
              <template v-if="text.record.detail_level === 1">
                All Details
              </template>
              <template v-else-if="text.record.detail_level === 2">
                Activity Summery
              </template>
              <template v-else-if="text.record.detail_level === 3">
                Aggregate
              </template>
            </span>
            <span slot="payed_amount" slot-scope="text,record">
              {{  text.record.payed_amount.toFixed(2) }}
            </span>
            <span slot="outstanding_balance" slot-scope="text,record">
              <span v-if="text.record.is_old_version || text.record.type === 2">{{ (text.record.total_amount - text.record.payed_amount).toFixed(2) }}</span>
              <span v-else>{{ (text.record.fixed_total_amount - text.record.payed_amount).toFixed(2) }}</span>
            </span>
            <span slot="total_amount" slot-scope="text,record">
              <span v-if="text.record.is_old_version || text.record.type === 2">{{ text.record.total_amount.toFixed(2) }}</span>
              <span v-else>{{ text.record.fixed_total_amount.toFixed(2) }}</span>
            </span>
            <span slot="first_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="second_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_second_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="third_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_skip_approval_process"></feather-icon>
          <feather-icons icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icons>
        </span>
            <span slot="status" slot-scope="text,record">
              <template v-if="text.record.status === 1">
                <a-tag color="purple">
                  Draft
                </a-tag>
              </template>
              <template v-else-if="text.record.status === 2">
                <a-tag color="blue">
                 Approved
                </a-tag>
             </template>
            <template v-else-if="text.record.status === 3">
              <a-tag color="yellow">
                Unpaid
              </a-tag>
            </template>
            <template v-else-if="text.record.status === 4">
              <a-tag color="green">
                Paid
              </a-tag>
            </template>
            </span>
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="clickRow(text.record)" v-if="hasPermission('billing.get') && text.record.status === 1"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                    <a-menu-item key="2" @click="deleteBill(text.record)" v-if="hasPermission('billing.delete')"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    <a-menu-item key="3" @click="ApproveBill(text.record,true)" v-if="hasPermission('billing.edit') && text.record.status === 1"><feather-icon icon="ActivityIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Approve</a-menu-item>
                    <a-menu-item key="4" @click="OpenSendEmail(text.record,true)" v-if="hasPermission('billing.fund.html') && text.record.status !== 4 && (text.record.total_amount - text.record.payed_amount !== 0)"><feather-icon icon="MailIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Send</a-menu-item>
                    <a-menu-item key="5" @click="ExportPdf(text.record)" v-if="hasPermission('billing.fund-request.pdf')"><a-icon type="file-pdf" theme="twoTone" two-tone-color="#ff0000" />Export Pdf</a-menu-item>
                    <a-menu-item key="6" @click="InvoiceDisplay(text.record,true)" v-if="hasPermission('billing.fund.html')"><feather-icon icon="MonitorIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>View</a-menu-item>
                    <a-menu-item key="7" @click="goToRecordPaymentOrSendFund(text.record)" v-if="hasPermission('billing.payment') && approveNotDueDate(text.record)"><feather-icon icon="DollarSignIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Record Payment</a-menu-item>
                    <a-menu-item key="8" @click="goToRecordPaymentOrSendFund(text.record,'sendFund')" v-if="hasPermission('billing.fund-request.send') && text.record.status === 2"><feather-icon icon="MessageCircleIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Send Payment Reminder</a-menu-item>

                    <!-- Only visible for bill/invoice (i.e. not fund request
                    or official receipt), and when the bill is either unpaid or
                    paid. -->
                    <a-menu-item 
                      key="9"
                      @click="sendToLhdn(text.record)"
                      v-if="(hasPermission('billing.fund-request.send') || hasPermission('billing.fund-request.pdf')) && (text.record.status === 3 || text.record.status === 4) && (text.record.type === BILLING_TYPE_BILL)"
                    >
                      <feather-icon icon="MailIcon" svg-classes="text-secondary w-4 h-4" class="pr-2"/>Send to LHDN
                    </a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px" @click="actionStatusBill(text.record)"> {{ statusBill(text.record) }} <a-icon type="down" /> </a-button>
                </a-dropdown>
              </span>
            <span slot="tax" slot-scope="text,record">
              {{ ((totalAmountTimesExpense(text.record) - text.record.discount) * (text.record.tax / 100)).toFixed(2) }}
            </span>
            <span v-if="text.record.matters && text.record.matters.length" slot="reference_code" slot-scope="text,record">
              {{ text.record.matters[0].reference_code }}
            </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane key="2" tab="Draft" force-render>
          <XTable class="mt-5"
                  ref="billDraft"
                  :model="model"
                  @clickRow="clickRow"
                  :options="{ placeholder:'Search bill',noContent: 'No bill',is_row_selection: false,is_load_req: false,temp_row: null }"
          >
            <span slot="issue_date" slot-scope="text,record">
              {{ setDateFormat(text.record.issue_date) }}
            </span>
            <span slot="due_date" slot-scope="text,record">
              {{ setDateFormat(text.record.due_date) }}
            </span>
            <span slot="bill_id" slot-scope="text,record">
              <a-button type="link" @click="dashboardId(text.record.id)">{{ text.record.factor_no }}</a-button>
            </span>
            <span slot="type" slot-scope="text,record">
              <template v-if="text.record.type === 1">
                Billing
              </template>
              <template v-if="text.record.type === 2">
                Funds Request
              </template>
            </span>
            <span slot="contact" slot-scope="text,record" v-if="text.record.to_contact">
                <template v-if="text.record.to_contact.person">
                   {{ text.record.to_contact.person.first_name }} {{ text.record.to_contact.person.last_name }}
                </template>
                <template v-else>
                   {{ text.record.to_contact.company.name }}
                </template>
            </span>
            <span slot="matter" slot-scope="text,record,index" class="flex flex-row">
                <div v-for="matter in text.record.matters">
                  <a-tag>
                    {{ matter.title }}
                  </a-tag>
              </div>
            </span>
            <span slot="level" slot-scope="text,record">
              <template v-if="text.record.detail_level === 1">
                All Details
              </template>
              <template v-else-if="text.record.detail_level === 2">
                Activity Summery
              </template>
              <template v-else-if="text.record.detail_level === 3">
                Aggregate
              </template>
            </span>
            <span slot="payed_amount" slot-scope="text,record">
              {{ Number.isInteger(text.record.payed_amount) || text.record.payed_amount < 1  ? text.record.payed_amount :text.record.payed_amount.toFixed(2) }}
            </span>
            <span slot="outstanding_balance" slot-scope="text,record">
              {{ (text.record.fixed_total_amount - text.record.payed_amount).toFixed(2) }}
            </span>
            <span slot="total_amount" slot-scope="text,record">
              {{ text.record.fixed_total_amount.toFixed(2) }}
            </span>
            <span slot="first_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="second_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_second_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="third_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_skip_approval_process"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="status" slot-scope="text,record">
              <template v-if="text.record.status === 1">
                <a-tag color="purple">
                  Draft
                </a-tag>
              </template>
              <template v-else-if="text.record.status === 2">
                <a-tag color="blue">
                 Approved
                </a-tag>
             </template>
            <template v-else-if="text.record.status === 3">
              <a-tag color="yellow">
                Unpaid
              </a-tag>
            </template>
            <template v-else-if="text.record.status === 4">
              <a-tag color="green">
                Paid
              </a-tag>
            </template>
            </span>
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="clickRow(text.record)" v-if="hasPermission('billing.get') && text.record.status === 1"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                    <a-menu-item key="2" @click="deleteBill(text.record)" v-if="hasPermission('billing.delete')"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    <a-menu-item key="3" @click="ApproveBill(text.record,true)" v-if="hasPermission('billing.edit') && text.record.status === 1"><feather-icon icon="ActivityIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Approve</a-menu-item>
                    <a-menu-item key="4" @click="OpenSendEmail(text.record,true)" v-if="hasPermission('billing.edit') && text.record.status === 2"><feather-icon icon="MailIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>Send</a-menu-item>
                    <a-menu-item key="5" @click="ExportPdf(text.record)" v-if="hasPermission('billing.fund-request.pdf')"><a-icon type="file-pdf" theme="twoTone" two-tone-color="#ff0000" />Export Pdf</a-menu-item>
                    <a-menu-item key="6" @click="InvoiceDisplay(text.record,true)" v-if="hasPermission('billing.fund.html')"><feather-icon icon="MonitorIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>View</a-menu-item>
                    <!--&lt;!&ndash;                    ExportPdf(text.record)&ndash;&gt; -->
                    <a-menu-item key="7" @click="goToRecordPaymentOrSendFund(text.record)" v-if="hasPermission('billing.payment') && approveNotDueDate(text.record)"><feather-icon icon="DollarSignIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Record Payment</a-menu-item>
                    <a-menu-item key="8" @click="goToRecordPaymentOrSendFund(text.record,'sendFund')" v-if="hasPermission('billing.fund-request.send') && text.record.status === 2"><feather-icon icon="MessageCircleIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Send Payment Reminder</a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px" @click="actionStatusBill(text.record)"> {{ statusBill(text.record) }} <a-icon type="down" /> </a-button>
                </a-dropdown>
              </span>
            <span slot="tax" slot-scope="text,record">
              {{ ((totalAmountTimesExpense(text.record) - text.record.discount) * (text.record.tax / 100)).toFixed(2) }}
            </span>
            <span v-if="text.record.matters && text.record.matters.length" slot="reference_code" slot-scope="text,record">
              {{ text.record.matters[0].reference_code }}
            </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane key="3" tab="Unpaid" force-render>
          <XTable
            class="mt-5"
            ref="billUnpaid"
            :model="model"
            @clickRow="clickRow"
            :options="{ placeholder:'Search bill',noContent: 'No bill',is_row_selection: false,is_load_req: false,temp_row: null }"
          >
            <span slot="bill_id" slot-scope="text,record">
              <a-button type="link" @click="dashboardId(text.record.id)">{{ text.record.factor_no }}</a-button>
            </span>
            <span slot="issue_date" slot-scope="text,record">
              {{ setDateFormat(text.record.issue_date) }}
            </span>
            <span slot="due_date" slot-scope="text,record">
              {{ setDateFormat(text.record.due_date) }}
            </span>
            <span slot="type" slot-scope="text,record">
              <template v-if="text.record.type === 1">
                Billing
              </template>
              <template v-if="text.record.type === 2">
                Funds Request
              </template>
            </span>
            <span slot="contact" slot-scope="text,record" v-if="text.record.to_contact">
                <template v-if="text.record.to_contact.person">
                   {{ text.record.to_contact.person.first_name }} {{ text.record.to_contact.person.last_name }}
                </template>
                <template v-else>
                   {{ text.record.to_contact.company.name }}
                </template>
            </span>
            <span slot="matter" slot-scope="text,record,index" class="flex flex-row">
                <div v-for="matter in text.record.matters">
                  <a-tag>
                    {{ matter.title }}
                  </a-tag>
              </div>
            </span>
            <span slot="level" slot-scope="text,record">
              <template v-if="text.record.detail_level === 1">
                All Details
              </template>
              <template v-else-if="text.record.detail_level === 2">
                Activity Summery
              </template>
              <template v-else-if="text.record.detail_level === 3">
                Aggregate
              </template>
            </span>
            <span slot="payed_amount" slot-scope="text,record">
              {{ Number.isInteger(text.record.payed_amount) || text.record.payed_amount < 1  ? text.record.payed_amount :text.record.payed_amount.toFixed(2) }}
            </span>
            <span slot="outstanding_balance" slot-scope="text,record">
              {{ (text.record.fixed_total_amount - text.record.payed_amount).toFixed(2) }}
            </span>
            <span slot="total_amount" slot-scope="text,record">
              {{ text.record.fixed_total_amount.toFixed(2) }}
            </span>
            <span slot="first_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="second_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_second_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="third_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_skip_approval_process"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="status" slot-scope="text,record">
              <template v-if="text.record.status === 1">
                <a-tag color="purple">
                  Draft
                </a-tag>
              </template>
              <template v-else-if="text.record.status === 2">
                <a-tag color="blue">
                 Approved
                </a-tag>
             </template>
            <template v-else-if="text.record.status === 3">
              <a-tag color="yellow">
                Unpaid
              </a-tag>
            </template>
            <template v-else-if="text.record.status === 4">
              <a-tag color="green">
                Paid
              </a-tag>
            </template>
            </span>
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="clickRow(text.record)" v-if="hasPermission('billing.get') && text.record.status === 1"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                    <a-menu-item key="2" @click="deleteBill(text.record)" v-if="hasPermission('billing.delete')"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    <a-menu-item key="3" @click="ApproveBill(text.record,true)" v-if="hasPermission('billing.edit') && text.record.status === 1"><feather-icon icon="ActivityIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Approve</a-menu-item>
                    <a-menu-item
                      key="4"
                      @click="OpenSendEmail(text.record,true)"
                      v-if="hasPermission('billing.fund.html') && text.record.status !== 4 && (text.record.total_amount - text.record.payed_amount !== 0)"
                    >
                      <feather-icon icon="MailIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>
                      Send
                    </a-menu-item>
                    <a-menu-item key="5" @click="ExportPdf(text.record)" v-if="hasPermission('billing.fund-request.pdf')"><a-icon type="file-pdf" theme="twoTone" two-tone-color="#ff0000" />Export Pdf</a-menu-item>
                    <a-menu-item key="6" @click="InvoiceDisplay(text.record,true)" v-if="hasPermission('billing.fund.html')"><feather-icon icon="MonitorIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>View</a-menu-item>
                    <!--&lt;!&ndash;                    ExportPdf(text.record)&ndash;&gt; -->
                    <a-menu-item key="7" @click="goToRecordPaymentOrSendFund(text.record)" v-if="hasPermission('billing.payment') && approveNotDueDate(text.record)"><feather-icon icon="DollarSignIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Record Payment</a-menu-item>
                    <a-menu-item key="8" @click="goToRecordPaymentOrSendFund(text.record,'sendFund')" v-if="hasPermission('billing.fund-request.send') && text.record.status === 2"><feather-icon icon="MessageCircleIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Send Payment Reminder</a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px" @click="actionStatusBill(text.record)"> {{ statusBill(text.record) }} <a-icon type="down" /> </a-button>
                </a-dropdown>
              </span>
            <span slot="tax" slot-scope="text,record">
              {{ ((totalAmountTimesExpense(text.record) - text.record.discount) * (text.record.tax / 100)).toFixed(2) }}
            </span>
            <span v-if="text.record.matters && text.record.matters.length" slot="reference_code" slot-scope="text,record">
              {{ text.record.matters[0].reference_code }}
            </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane key="4" tab="Overdue" force-render>
          <XTable
            class="mt-5"
            ref="billOverdue"
            :model="model"
            @clickRow="clickRow"
            :options="{ placeholder:'Search bill',noContent: 'No bill',is_row_selection: false,is_load_req: false,temp_row: null }"
          >
            <span slot="bill_id" slot-scope="text,record">
              <a-button type="link" @click="dashboardId(text.record.id)">{{ text.record.factor_no }}</a-button>
            </span>
            <span slot="issue_date" slot-scope="text,record">
              {{ setDateFormat(text.record.issue_date) }}
            </span>
            <span slot="due_date" slot-scope="text,record">
              {{ setDateFormat(text.record.due_date) }}
            </span>
            <span slot="type" slot-scope="text,record">
              <template v-if="text.record.type === 1">
                Billing
              </template>
              <template v-if="text.record.type === 2">
                Funds Request
              </template>
            </span>
            <span slot="contact" slot-scope="text,record" v-if="text.record.to_contact">
                <template v-if="text.record.to_contact.person">
                   {{ text.record.to_contact.person.first_name }} {{ text.record.to_contact.person.last_name }}
                </template>
                <template v-else>
                   {{ text.record.to_contact.company.name }}
                </template>
            </span>
            <span slot="matter" slot-scope="text,record,index" class="flex flex-row">
                <div v-for="matter in text.record.matters">
                  <a-tag>
                    {{ matter.title }}
                  </a-tag>
              </div>
            </span>
            <span slot="level" slot-scope="text,record">
              <template v-if="text.record.detail_level === 1">
                All Details
              </template>
              <template v-else-if="text.record.detail_level === 2">
                Activity Summery
              </template>
              <template v-else-if="text.record.detail_level === 3">
                Aggregate
              </template>
            </span>
            <span slot="payed_amount" slot-scope="text,record">
              {{ Number.isInteger(text.record.payed_amount) || text.record.payed_amount < 1  ? text.record.payed_amount :text.record.payed_amount.toFixed(2) }}
            </span>
            <span slot="outstanding_balance" slot-scope="text,record">
              {{ (text.record.fixed_total_amount - text.record.payed_amount).toFixed(2) }}
            </span>
            <span slot="total_amount" slot-scope="text,record">
              {{ text.record.fixed_total_amount.toFixed(2) }}
            </span>
            <span slot="first_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="second_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_apply_second_task"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="third_task" slot-scope="text,record">
          <feather-icon icon="CheckIcon" svg-classes="w-4 h-4 text-success" v-if="text.record.is_skip_approval_process"></feather-icon>
          <feather-icon icon="XIcon" svg-classes="w-4 h-4 text-danger" v-else></feather-icon>
        </span>
            <span slot="status" slot-scope="text,record">
              <template v-if="text.record.status === 1">
                <a-tag color="purple">
                  Draft
                </a-tag>
              </template>
              <template v-else-if="text.record.status === 2">
                <a-tag color="blue">
                 Approved
                </a-tag>
             </template>
            <template v-else-if="text.record.status === 3">
              <a-tag color="yellow">
                Unpaid
              </a-tag>
            </template>
            <template v-else-if="text.record.status === 4">
              <a-tag color="green">
                Paid
              </a-tag>
            </template>
            </span>
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="clickRow(text.record)" v-if="hasPermission('billing.get') && text.record.status === 1"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                    <a-menu-item key="2" @click="deleteBill(text.record)" v-if="hasPermission('billing.delete')"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    <a-menu-item key="3" @click="ApproveBill(text.record,true)" v-if="hasPermission('billing.edit') && text.record.status === 1"><feather-icon icon="ActivityIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Approve</a-menu-item>
                    <a-menu-item
                      key="4"
                      @click="OpenSendEmail(text.record,true)"
                      v-if="hasPermission('billing.fund.html') && text.record.status !== 4 && (text.record.total_amount - text.record.payed_amount !== 0)"
                    >
                      <feather-icon icon="MailIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>
                      Send
                    </a-menu-item>
                    <a-menu-item key="5" @click="ExportPdf(text.record)" v-if="hasPermission('billing.fund-request.pdf')"><a-icon type="file-pdf" theme="twoTone" two-tone-color="#ff0000" />Export Pdf</a-menu-item>
                    <a-menu-item key="6" @click="InvoiceDisplay(text.record,true)" v-if="hasPermission('billing.fund.html')"><feather-icon icon="MonitorIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>View</a-menu-item>
                    <!--&lt;!&ndash;                    ExportPdf(text.record)&ndash;&gt; -->
                    <a-menu-item key="7" @click="goToRecordPaymentOrSendFund(text.record)" v-if="hasPermission('billing.payment') && approveNotDueDate(text.record)"><feather-icon icon="DollarSignIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Record Payment</a-menu-item>
                    <a-menu-item key="8" @click="goToRecordPaymentOrSendFund(text.record,'sendFund')" v-if="hasPermission('billing.fund-request.send') && text.record.status === 2"><feather-icon icon="MessageCircleIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>Send Payment Reminder</a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px" @click="actionStatusBill(text.record)"> {{ statusBill(text.record) }} <a-icon type="down" /> </a-button>
                </a-dropdown>
              </span>
            <span slot="tax" slot-scope="text,record">
              {{ ((totalAmountTimesExpense(text.record) - text.record.discount) * (text.record.tax / 100)).toFixed(2) }}
            </span>
            <span v-if="text.record.matters && text.record.matters.length" slot="reference_code" slot-scope="text,record">
              {{ text.record.matters[0].reference_code }}
            </span>
          </XTable>
        </a-tab-pane>
        <a-tab-pane key="5" tab="Receipt" force-render>
          <XTable
            class="mt-5"
            ref="billReceipt"
            :model="modelReceipt"
            @clickRow="clickRow"
            :options="{ placeholder:'Search Receipt',noContent: 'No bill',is_row_selection: false,is_load_req: false,temp_row: null }"
          >
            <span slot="payment_type" slot-scope="text,record">
                <template v-if="text.record.payment_type === 1">
                  Deposit
                </template>
                <template v-if="text.record.payment_type === 2">
                  Cheque
                </template>
                <template v-if="text.record.payment_type === 3">
                  Cash
                </template>
                <template v-if="text.record.payment_type === 4">
                  Online Transfer
                </template>
            </span>
            <span slot="receive_from" slot-scope="text,record" v-if="text.record.receive_from">
                <template v-if="text.record.receive_from.person">
                   {{ text.record.receive_from.person.first_name }} {{ text.record.receive_from.person.last_name }}
                </template>
                <template v-else>
                   {{ text.record.receive_from.company.name }}
                </template>
            </span>
            <span slot="action" slot-scope="text,record" class="flex space-x-3">
                <a-dropdown>
                  <a-menu slot="overlay">
                    <a-menu-item key="1" @click="editReceipt(text.record)"><feather-icon icon="EditIcon" svg-classes="text-primary w-4 h-4" class="pr-2"/>Edit</a-menu-item>
                    <a-menu-item key="2" @click="deleteReceipt(text.record)"><feather-icon icon="TrashIcon" svg-classes="text-danger w-4 h-4" class="pr-2"/>Delete</a-menu-item>
                    <a-menu-item
                      key="4"
                      @click="OpenSendEmail(text.record)"
                    >
                      <feather-icon icon="MailIcon" svg-classes="text-success w-4 h-4" class="pr-2"/>
                      Send
                    </a-menu-item>
                    <a-menu-item key="5" @click="ExportPdf(text.record)"><a-icon type="file-pdf" theme="twoTone" two-tone-color="#ff0000" />Export Pdf</a-menu-item>
                    <a-menu-item key="6" @click="InvoiceDisplay(text.record)"><feather-icon icon="MonitorIcon" svg-classes="text-warning w-4 h-4" class="pr-2"/>View</a-menu-item>
                  </a-menu>
                  <a-button style="margin-left: 8px"> Actions <a-icon type="down" /> </a-button>
                </a-dropdown>
              </span>
            <span slot="amount" slot-scope="text,record">{{ text.record.amount.toFixed(2) }}</span>
            <span slot="date" slot-scope="text,record">{{ setDateFormat(text.record.date) }}</span>
            <span slot="bank_date" slot-scope="text,record">{{ setDateFormat(text.record.bank_in_date) }}</span>
            <span slot="factor_no" slot-scope="text,record">
              <a-button v-if="text.record.payment_for" type="link" @click="dashboardId(text.record.payment_for.id)">{{ text.record.payment_for.factor_no }}</a-button>
            </span>
            <span slot="receipt_no" slot-scope="text,record">
              {{ 'OR00' + text.record.receipt_no }}
            </span>
          </XTable>
        </a-tab-pane>
      </a-tabs>

      <div id="billing-error-messages">
        <div v-if="lhdnErrors.length" class="mt-8">
          <a-alert 
            v-for="(error, index) in lhdnErrors"
            :message="`${error.name}: ${error.msg}`"
            type="error"
            show-icon
            closable
            class="mb-4"
          />
        </div>
      </div>
    </vx-card>

    <deleteItem
      :url="`/billing/${temp_row}/`"
      subject="Bill"
      :ele="$refs[refsTblBill(tab_bill)]"
      ref="billDelete"
    />

    <deleteItem
      :url="`/billing/fund-request/${temp_row}/`"
      subject="Bill"
      :ele="$refs.ClientFund"
      ref="billDeleteClientFund"
    />

    <deleteItem
      :url="`/billing/official-receipt/${temp_row}/`"
      subject="Bill Receipt"
      :ele="$refs.billReceipt"
      ref="billDeleteReceipt"
    />

    <a-modal centered class="billing" title="Generate Invoices" :visible="open_edit_billing" @cancel="open_edit_billing = false" :width="750">
      <a-form :form="form" @submit.prevent="handleEditBill">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <a-form-item label="Issue date" has-feedback>
            <a-date-picker
              v-decorator="['issue_date',{ initialValue: new Date().toISOString().split('T')[0],rules: [{ required: true, message: 'This filed is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
          <a-form-item label="Due date" has-feedback>
            <a-date-picker
              v-decorator="['due_date',{ initialValue:new Date().toISOString().split('T')[0] ,rules: [{ required: true, message: 'This filed is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
        </div>
        <a-form-item label="Detail Level" has-feedback>
          <a-select
            placeholder="condition"
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['detail_level',{ initialValue: '1' }]"
          >
            <a-select-option value="1">
              All Details
            </a-select-option>
            <a-select-option value="2">
              Activity Summary
            </a-select-option>
          </a-select>
        </a-form-item>

        <BillFaxComponent :form="form" :is_disabled="true" />

        <a-divider/>

        <div class="flex space-x-2">
          <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save</a-button>
          <a-button type="border" ghsot style="border-radius: 3px" @click="open_edit_billing = false">Cancel</a-button>
        </div>

      </a-form>
    </a-modal>

    <a-modal centered class="billing" title="New Trust Fund Request" :visible="open_fund_client" @cancel="open_fund_client = false" :width="750">
      <a-form :form="form_client_fund" @submit.prevent="handleClientFundBill">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <a-form-item label="Due date" has-feedback>
            <a-date-picker
              v-decorator="['due_date',{ initialValue: currentDateFormat ,rules: [{ required: true, message: 'This filed is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
          <a-form-item label="Issue date" has-feedback>
            <a-date-picker
              v-decorator="['issue_date',{ initialValue: currentDateFormat ,rules: [{ required: true, message: 'This filed is required.' }] }]"
              placeholder="dd/mm/yyyy"
              :format="dateFormat"
              valueFormat="YYYY-MM-DD"
              class="w-full"
            />
          </a-form-item>
<!--          <a-form-item label="Amount" has-feedback>-->
<!--            <a-input-->
<!--              placeholder="0.00"-->
<!--              style="width: 100%"-->
<!--              allowClear-->
<!--              class="select"-->
<!--              v-decorator="['total_amount',{ rules: [{ required: true, message: 'This filed is required.' },{ pattern: /^\d+$/, message: 'You can only enter numbers.' }] }]"-->
<!--            />-->
<!--          </a-form-item>-->
          <selectSearch
            url="/contact/query/"
            :required="true"
            :options="{ label:'Client',field: 'client',placeholder: 'Type to search client',allow_clear:true }"
            @selectSearchValue="selectSearchValue"
          />

          <a-form-item label="Balance type" has-feedback>
            <a-select
              style="width: 100%"
              allowClear
              class="select"
              v-decorator="['balance',{ initialValue: '1' }]"
              @select="handleSelectType"
            >
              <a-select-option value="1">
                Client
              </a-select-option>
              <a-select-option value="2">
                Matter
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>

        <ACard class="mt-5" v-show="is_client_type">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <selectSearch
                :required="is_client_type"
                url="/matter/query/"
                :options="optionSearchMatter"
                class="self-center mt-8 md:mt-0 w-full"
                :is_include_matter="true"
                ref="matter"
              />
<!--            <a-form-item label="Matter" has-feedback>-->
<!--              <a-select-->
<!--                placeholder="Select source matter"-->
<!--                allowClear-->
<!--                class="select"-->
<!--                v-decorator="['matter',{rules: [{ required: true, message: 'This field is required.' }] }]"-->
<!--              >-->
<!--                <a-select-option v-for="matter in matters" :value="matter.id">-->
<!--                  {{ matter.title }}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
<!--            </a-form-item>-->
            <a-form-item label="Amount" has-feedback>
                <a-input
                  placeholder="0.00"
                  style="width: 100%"
                  allowClear
                  class="select"
                  v-decorator="['total_amount',{ rules: [{ required: true, message: 'This filed is required.' }] }]"
                />
            </a-form-item>
          </div>
        </ACard>
        <a-form-item v-show="!is_client_type" label="Amount" has-feedback>
          <a-input
            placeholder="0.00"
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['total_amount',{ rules: [{ required: true, message: 'This filed is required.' }] }]"
          />
        </a-form-item>


        <a-form-item label="Description" has-feedback>
          <a-textarea
            style="width: 100%"
            class="select"
            v-decorator="['note',{ rules: [{ required: false, message: 'This filed is required.' }] }]"
          />
        </a-form-item>

<!--        <a-form-item>-->
<!--          <a-checkbox-->
<!--            style="width: 100%"-->
<!--            class="select"-->
<!--            v-decorator="['skip_client',{ rules: [{ required: false, message: 'This filed is required.' }] }]"-->
<!--          >-->
<!--            Skip the client funds request approval process-->
<!--          </a-checkbox>-->
<!--        </a-form-item>-->


        <a-divider/>

        <div class="flex space-x-2">
          <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save</a-button>
          <a-button type="primary" ghost style="border-radius: 3px" @click="open_fund_client = false">Cancel</a-button>
        </div>

      </a-form>
    </a-modal>

    <a-modal centered class="billing" title="Send Reminder" :visible="open_send_email" @cancel="open_send_email = false" :width="750">
      <a-form :form="form_send" @submit.prevent="handleSendBill">
        <a-form-item label="Contacts" has-feedback>
            <a-select
              style="width: 100%"
              allowClear
              class="select"
              mode="multiple"
              show-search
              :filter-option="filterOption"
              v-decorator="['to_contacts',{rules: [{ required: true, message: 'This filed is required.' }]}]"
            >
              <a-select-option v-for="contact in contacts" :value="contact.id">
                <template v-if="contact.person">
                    {{ contact.person.first_name }} {{ contact.person.last_name }} ({{contact.emails.length ? contact.emails[0].email_address : 'No email'}})
                </template>
                <template v-else>
                    {{ contact.company.name }}  {{ (contact.emails.length ? contact.emails[0].email_address : 'No email') }}
                </template>
              </a-select-option>
            </a-select>
        </a-form-item>

<!--        <p class="text-xl font-semibold mt-5">Message</p>-->

<!--        <a-form-item label="Email template" has-feedback>-->
<!--          <a-select-->
<!--            style="width: 100%"-->
<!--            allowClear-->
<!--            class="select"-->
<!--            v-decorator="['template']"-->
<!--          >-->
<!--            <a-select-option :value="1">-->
<!--                Bills template-->
<!--            </a-select-option>-->
<!--            <a-select-option :value="2">-->
<!--              Default Client Funds template-->
<!--            </a-select-option>-->
<!--            <a-select-option :value="3">-->
<!--              Outstanding Balance template-->
<!--            </a-select-option>-->
<!--            <a-select-option :value="4">-->
<!--              Reminders template-->
<!--            </a-select-option>-->
<!--          </a-select>-->
<!--        </a-form-item>-->

        <a-form-item label="Subject" has-feedback>
          <a-input
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['title',{rules: [{ required: true, message: 'This filed is required.' }]}]"
          >
          </a-input>
        </a-form-item>

        <a-form-item label="Body" has-feedback>
          <a-textarea
            style="width: 100%"
            allowClear
            class="select"
            :rows="5"
            v-decorator="['message',{rules: [{ required: true, message: 'This filed is required.' }]}]"
          >
          </a-textarea>
        </a-form-item>

        <a-divider/>

        <div class="flex gap-x-2">
          <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save</a-button>
          <a-button type="primary" ghost style="border-radius: 3px" @click="open_send_email = false">Cancel</a-button>
        </div>

      </a-form>
    </a-modal>

    <BillingViewModal 
      centered
      :closable="false"
      class="billing billing-view"
      :visible="open_invoice_display"
      @cancel="open_invoice_display = false"
      :width="750"
      :bill-type="tab_bill"
      :is-loading="skeleton_show"
      :invoice_html="invoice_html"
      :template_data="template_data"
      :approveNotDueDateCallback="approveNotDueDate"
    />

    <a-modal title="New Official Receipt" centered :visible="visibleReceipt" @cancel="visibleReceipt = false" :width="750">
      <a-form :form="formReceipt" @submit.prevent="handleReceipt">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <selectSearch
            ref="clientReceipt"
            url="/contact/query/"
            :required="true"
            :options="{ label:'Client',field: 'receive_from',placeholder: 'Type to search client',allow_clear:true }"
            @selectSearch="handlerChangeReceipt"
          />
          <a-form-item label="Bill" has-feedback>
            <a-select
              allowClear
              class="w-full select"
              show-search
              :loading="loadingReceipt"
              :disabled="!hasReceiptClient"
              :filter-option="filterOption"
              v-decorator="['payment_for',{rules: [{ required: true, message: 'This filed is required.' }]}]"
            >
              <a-select-option v-for="(receipt, i) in receiptes" :key="receipt.id" :value="receipt.id">
                Invoice No: {{ receipt.factor_no }} -
                <span v-if="receipt.is_old_version">{{ `${currencySymbol} ${receipt.total_amount}` }}</span>
                <span v-else>{{ `${currencySymbol} ${receipt.fixed_total_amount}` }}</span>
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div v-show="hasReceiptClient">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <a-form-item label="Payment type" has-feedback>
              <a-select
                allowClear
                class="w-full select"
                show-search
                v-decorator="['payment_type',{rules: [{ required: false, message: 'This filed is required.' }]}]"
              >
                <a-select-option :value="1">
                  Deposit
                </a-select-option>
                <a-select-option :value="2">
                  Cheque
                </a-select-option>
                <a-select-option :value="3">
                  Cash
                </a-select-option>
                <a-select-option :value="4">
                  Online Transfer
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Amount" has-feedback>
              <a-input
                allowClear
                class="select"
                v-decorator="['amount',{ rules: [{ required: true, message: 'This filed is required.' }] }]"
              />
            </a-form-item>
            <a-form-item label="Date" has-feedback>
              <a-date-picker
                v-decorator="['date',{ rules: [{ required: false }] }]"
                :format="dateFormat"
                valueFormat="YYYY-MM-DD"
                autocomplete="off"
                class="w-full md:w-1/2"
              />
            </a-form-item>
            <a-form-item label="Bank in Date" has-feedback>
              <a-date-picker
                v-decorator="['bank_in_date',{ rules: [{ required: false }] }]"
                valueFormat="YYYY-MM-DD"
                :format="dateFormat"
                autocomplete="off"
                class="w-full md:w-1/2"
              />
            </a-form-item>
          </div>
          <a-form-item label="Remark" has-feedback>
            <a-input
              allowClear
              class="select"
              v-decorator="['remark',{ rules: [{ required: false, message: 'This filed is required.' }] }]"
            />
          </a-form-item>
          <a-divider/>
          <div class="flex gap-x-2">
            <a-button type="primary" html-type="submit">Save</a-button>
            <a-button type="primary" ghost @click="visibleReceipt = false">Cancel</a-button>
          </div>
        </div>
      </a-form>
    </a-modal>

    <Drawer
      ref="drawer"
      :form="form"
      :ele="$refs[`${refsTblBill(tab_bill)}`]"
      :query="[
                { field : 'matters__client__id', value: form.getFieldValue('client') ,  condition: '=' },
                { field : 'matters__id', value: form.getFieldValue('matter') ,  condition: '=' },
                { field : 'due_date', value: form.getFieldValue('due_date') ,  condition: '=' },
                { field : 'issue_date', value: form.getFieldValue('issue_date') ,  condition: '=' },
                { field : 'group', value: form.getFieldValue('group') ,  condition: '=' },
                { field : 'location', value: form.getFieldValue('location') ,  condition: 'like' },
                { field : 'reference_code', value: form.getFieldValue('reference_code') ,  condition: 'like' },
      ]"
    >
      <selectSearch
        :options="{placeholder: 'Search contacts',label: 'Client',field: 'client',width: '100%',allow_clear: true}"
      />
      <selectSearch
        url="/matter/query/"
        :options="{placeholder: 'Search matters',label: 'Matter',field: 'matter',width: '100%',allow_clear: true}"
        class="md:mt-0 w-full"
        :is_include_matter="true"
      />
      <a-form-item label="Payment Date" has-feedback>
        <a-date-picker
          v-decorator="['due_date',{ rules: [{ required: false }] }]"
          :format="dateFormat"
          valueFormat="YYYY-MM-DD"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="Invoice Date" has-feedback>
        <a-date-picker
          v-decorator="['issue_date',{ rules: [{ required: false }] }]"
          valueFormat="YYYY-MM-DD"
          :format="dateFormat"
          autocomplete="off"
        />
      </a-form-item>
      <div
        :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'left',
          zIndex: 1,
        }"
      >
        <div class="flex gap-2">
          <a-button type="primary" html-type="submit" style="border-radius: 3px !important">
            Save filter
          </a-button>
          <a-button type="primary" ghost @click="exportTbl" :loading="loadingExport" style="border-radius: 3px !important;">
            Export
          </a-button>
        </div>
      </div>
    </Drawer>

  </div>
</template>

<script>
import * as TableCol from "./billTbl";
import * as TableColReceipt from "./receiptTbl";
import XTable from "../../components/x-table/XTable";
import Mixin from '../mixin/mixin'
import SelectOption from "../forms/SelectOptionSingle"
import selectSearch from "@/views/forms/selectSearch";
import axios from '@/axios'
import deleteItem from '../communications/deleteItem'
import moment from 'moment'
import TemplatePdf from '../template/TempPdf1'
import BillFaxComponent from "@/components/bill-fax/BillFaxComponent";
import Drawer from '../drawer/Drawer'
import BillingViewModal from './components/BillingViewModal.vue'

export default {
    name: "billingList",

    mixins: [Mixin],

    props: {
      hasFilterContact:{
        type: Boolean,
        default: false
      }
    },

    components:{
      BillFaxComponent,
      XTable,
      SelectOption,
      selectSearch,
      deleteItem,
      TemplatePdf,
      Drawer,
      BillingViewModal,
    },

    data() {
      return {
        BILLING_TYPE_BILL         : 1,
        BILLING_TYPE_FUND_REQUEST : 2,

        model        : null,
        modelReceipt : null,
        openQuickBill: false,
        edit_mode    : false,
        temp_row     : undefined,
        row          : undefined,
        contact_value: undefined,
        billing_type : 'all',
        open_edit_billing: false,
        open_fund_client: false,
        open_send_email: false,
        is_client_type: false,
        visibleReceipt: false,
        hasReceiptClient: false,
        open_invoice_display: false,
        contacts: [],
        matters: [],
        receiptes: [],
        invoice_html: {},
        skeleton_show: false,
        form_send: this.$form.createForm(this, {name: 'coordinated'}),
        form_client_fund: this.$form.createForm(this, {name: 'coordinated'}),
        formReceipt: this.$form.createForm(this, {name: 'coordinated'}),
        tab_bill: '1',
        template_data: {},
        loading:false,
        loadingReceipt: false,
        lhdnErrors: [],
      }
    },
    methods: {
	    async handlerChangeReceipt(value) {
        if (value) {
          try {
            this.loadingReceipt = true
            this.hasReceiptClient = true
            this.receiptes = []
            this.formReceipt.setFieldsValue({ payment_for: null })
            const { data } = await axios.post('/billing/query/',{ query: [{ field: 'to_contact', value, condition: '=' }], limit: 100 })
            this.receiptes = data.rows
          }catch (e) {
            throw e
          }finally {
            this.loadingReceipt = false
          }
        } else this.hasReceiptClient = false
      },

      async finalClose(val){
        if (val) {
          this.open_invoice_display = false
          await this.$refs.bill.fetch()
        }
      },

      async ExpertPdf(){
        try{
          this.loading = true
          await this.$refs.html2Pdf.generatePdf();
        }catch (e) {
          throw e
        }finally {
          this.loading = false
        }
      },

      async exportTbl() {
        try{
          this.loadingExport = true
          const columns = this.$refs.bill.cols
          const columns_filtered = columns.filter((item)=> item.key !== "action" && item.show).map(item => ({[item.title]: item.dataIndex }))
          const result = columns_filtered.reduce(function(result, item) {
            let key = Object.keys(item)[0];
            result[key] = item[key];
            return result;
          }, {});
          const {data} = await axios.post('billing/query/',{
            export: true,
            columns: result,query:this.$refs.drawer.query.filter((item)=>item.value),
            limit: 1000
          })
          window.open(data.url,'_self')
        }catch (e) {
          this.$message.error('Error')
          throw e
        }finally {
          this.loadingExport = false
        }
      },

      showDrawer(){
        this.$refs.drawer.visible_drawer = true
      },

      async handleChangeFilterStatus(value){
        try{
          this.checkPagenation(this.$refs.bill)
          value === undefined ? this.$refs.bill.query.query = undefined : this.$refs.bill.query.query = [{ field:'status',condition:'=',value: value }]
          await this.$refs.bill.fetch()
        }catch (e) {
          this.$message.error('Error')
          throw new Error(e)
        }
      },

      goToRecordPaymentOrSendFund(record,option = undefined){
        this.temp_row = record
        option ? this.open_send_email = true :
          this.$router.push({ path: '/billing/record-payment', query: { client_id: record.to_contact.id,type: record.type }})
        // this.$router.push({ path: '/billing/request-fund', query: { send_fund: record.id }})
      },

      approveNotDueDate(record){
        return (record.status === 2 || record.status === 3) && (moment().format('YYYY-MM-DD') >= moment(record.due_date).format('YYYY-MM-DD'))
      },

      approveDueDate(record){
        return (record.status === 2 || record.status === 3) && (moment().format('YYYY-MM-DD') <= moment(record.due_date).format('YYYY-MM-DD'))
      },

      statusBill(record){
        if (record.status === 1)
          return 'Approve'
        else if(this.approveDueDate(record))
          return 'Record Payment'
        else if(this.approveNotDueDate(record))
          return 'Send Reminder'
        else if(record.status === 4)
          return 'View'
        else if(record.status === 3)
          return 'Unpaid'
      },

      actionStatusBill(record){
        this.is_click_add_time = false
        if(record.status === 1)
          this.ApproveBill(record,true)
        else if(record.status === 4)
          this.InvoiceDisplay(record,true)
        else if(this.approveDueDate(record))
          this.goToRecordPaymentOrSendFund(record)
        else if(this.approveNotDueDate(record))
          this.OpenSendEmail(record,true)
      },

      dashboardId(id){
        this.is_click_add_time = false
        this.$router.push(`/billing/dashboard/${id}`)
      },

      async selectSearchValue(value){
        if (this.is_client_type) {
          const query = [{ field:'client__id',condition:'=',value: value || this.form_client_fund.getFieldValue('client') }]
          const { data } = await axios.post('/matter/query/',{ query, limit: 50 })
          this.$refs.matter.matters = data.rows
        }
      },

      async ExportPdf(record){
        const templateType = this.$store.state.settings.template_type
        try {
          if (templateType === 'unset')
            throw new Error('Template type is not initialized')
          //this.$vs.loading()
          const url = this.tab_bill === '5' ? `billing/official-receipt/${record.id}/pdf/` : `/billing/${record.id}/pdf${templateType}/`
          const {data} = await axios.get(url)
          window.open(data.url,'_self')
          await this.$refs.bill.fetch()
        } catch (e) {
          this.$message.error('Error in Exporting Pdf')
        }finally {
          //this.$vs.loading.close()
        }
      },

      refreshBill(){
        this.billing_type = 'all'
      },

      async tabClick(key){
        this.tab_bill = key
        this.$refs[`${this.refsTblBill(key)}`].data = []
        if (key === '1')
          this.$refs.bill.query.query = []
        if (key === '2')
          this.$refs.billDraft.query.query  = [{ field:'status',condition:'=',value: 1 }]
        if (key === '3')
          this.$refs.billUnpaid.query.query = [{ field:'status',condition:'=',value: 3 }]
        if (key === '4')
          this.$refs.billOverdue.query.query = [
            { field:'due_date', condition:'<', value: moment().format('YYYY-MM-DD'), operation: 'and' },
            { field:'status', condition:'<', value: 4, operation: 'and' },
            // { field:'status'  ,condition:'=',value: 3 , operation: 'or' },
            { field:'due_date', condition:'<', value: moment().format('YYYY-MM-DD'), operation: 'and' }
        ]
        if (this.hasFilterContact)
          this.$refs[`${this.refsTblBill(key)}`].query.query = [...this.$refs[`${this.refsTblBill(key)}`].query.query,{ field: 'to_contact',condition:'=',value: this.$store.state.dashboard_contact_id || this.$route.params.id }]
        await this.$refs[`${this.refsTblBill(key)}`].fetch()
      },

      refsTblBill(key){
        if (key === '1') return 'bill'
        if (key === '2') return 'billDraft'
        if (key === '3') return 'billUnpaid'
        if (key === '4') return 'billOverdue'
        if (key === '5') return 'billReceipt'
      },

      paymentType(type) {
        if (type === 1) return 'Deposit'
        if (type === 2) return 'Cheque'
        if (type === 3) return 'Cash'
        if (type === 4) return 'Online Transfer'
        return '-'
      },

      async InvoiceDisplay(record){
        try {
          // NOTE: tab_bill === 5 is receipt.
          
          this.open_invoice_display = true
          this.skeleton_show        = true
          const url                 = this.tab_bill !== '5' ? `/billing/${record.id}/data/` : `billing/official-receipt/${record.id}/data/`
          const res                 = await axios.get(url)

          console.log('tab bill', this.tab_bill)

          if (this.tab_bill !== '5') {
            // Official receipts don't neither tax nor discount.
            const { data: taxData }      = await axios.get(`billing/${record.id}/tax/`)
            const { data: discountData } = await axios.get(`billing/${record.id}/discount/`)
            
            const { data }            = await axios.get('/setting/firm/')
            this.template_data        = {
              discount_data: discountData,
              matter_taxes: taxData,
              accounts: data.setting.accounts || undefined,
              tax: data.setting.tax || undefined,
              templates: data.setting.templates === undefined ? {template: 1 ,avatar: null,description: null} : data.setting.templates
            }
          }
          this.invoice_html = (this.tab_bill !== '5') ? { data: res.data , record } :
            {
              ...res.data,
              payment_for : record.payment_for.matters && record.payment_for.matters.length ? record.payment_for.matters[0].title : '',
              payment_type: this.paymentType(record.payment_type),
              post_code   : record.payment_for.to_contact.addresses.length ? record.payment_for.to_contact.addresses[0].post_code || '' : null,
              city        : record.payment_for.to_contact.addresses.length ? record.payment_for.to_contact.addresses[0].city || '' : null,
              state       : record.payment_for.to_contact.addresses.length ? record.payment_for.to_contact.addresses[0].state || '' : null,
            }
          this.skeleton_show        = false
        }catch (e) {
          this.$message.error('Error receiving data')
          this.open_invoice_display = false
          throw e
        }
      },

      OpenSendEmail(record,is_send_bill){
        this.open_send_email = true
        this.temp_row = record
        this.temp_row.is_send_bill = is_send_bill
      },

      async getContacts(){
        try {
          const { data } = await axios.post('/contact/query/',{ limit: 9999 })
          this.contacts = data.rows.filter(item => item.person || item.company)
        }catch (e) {
          throw e
        }
      },

      async handleSelectType(value){
       // this.is_client_type = (value === '2')
        if (value === '2') {
          this.is_client_type = true
          await this.selectSearchValue()
        } else
          this.is_client_type = false
      },

      openApprove(record){
        this.temp_row = record.id
        this.$refs.approveDelete.open = true
      },

      handleSearchContact(value){
        this.contact_value = value
      },

      CancelBill(){
        this.openQuickBill = false
        setTimeout(()=>this.form.resetFields(),200)
      },

      clickRow(record){
        if (this.hasPermission('billing.get')) {
          if(this.is_click_add_time && record.status === 1){
            this.open_edit_billing = true
            this.temp_row      = record
            this.$nextTick(()=>{this.getRecordRow(record)})
          }else
            this.is_click_add_time = true
        }
      },

      async ApproveBill(record,ref){
        try{
          ref ? this.$refs.bill.loading = true : this.$refs.ClientFund.loading = true
          await axios.put(ref ?`/billing/${record.id}/` : `/billing/fund-request/${record.id}/`,{ status: 2 })
          ref ? await this.$refs.bill.fetch() : await this.$refs.ClientFund.fetch()
          this.$notification['success']({
            message: 'Success',
            description: `Bill approved.`,
          });
        }catch (e) {
          this.$notification['error']({
            message: 'error',
            description: `Bill approved failed.`,
          });
        }finally {
          ref ? this.$refs.bill.loading = false : this.$refs.ClientFund.loading = false
        }
      },

      async getRecordRow(record){
        try{
          this.$vs.loading()
          const { data } = await axios.get(`/billing/${record.id}/`);
          this.row       = data
          data.detail_level = `${data.detail_level}`
          data.from_user ? data.from_user = data.from_user.id : data.from_user = undefined
          data.matter ? data.matter = data.matter.title : data.matter = undefined
          data.to_contact && data.to_contact.person ? data.to_contact = `${data.to_contact.person.first_name} ${data.to_contact.person.last_name}` : data.to_contact = undefined
          this.form.setFieldsValue(data)
        }catch (e){
          this.$message.error('Server error')
        }finally {
          this.$vs.loading.close()
        }
      },

      deleteBill(record){
        this.temp_row = record.id
        this.$refs.billDelete.open = true
      },

      deleteReceipt(record) {
        this.temp_row = record.id
        this.$refs.billDeleteReceipt.open = true
      },

      deleteBillClientFund(record){
        this.temp_row = record.id
        this.$refs.billDeleteClientFund.open = true
      },

      addQuickBill(){
        this.$router.push('/billing/add')
        // this.edit_mode     = false
        // this.openQuickBill = true
      },

      handleClientFundBill(){
        this.form_client_fund.validateFields(async(err,values)=>{
          if(!err){
            try{
              this.$vs.loading()
              values.balance = undefined
              if (!this.is_client_type)
                delete values.matter
              await axios.post('/billing/fund-request/',values)
              this.open_fund_client = false
              this.$notification['success']({
                message: 'Success',
                description: `Client fund created.`,
              });
              this.form_client_fund.resetFields()
              this.is_client_type = false
              this.$refs.bill.fetch().then(()=>{})
            }catch (e) {
              this.$notification['error']({
                message: 'Failed',
                description: `Client fund failed.`,
              });
            }finally {
              this.$vs.loading.close()
            }
          }
        })
      },

      sendReminderUrl(temp) {
        if (temp.is_send_bill) return `/billing/${temp.id}/send/`
        if (this.tab_bill === '5') return `/billing/official-receipt/${temp.id}/send/`
        else return `/billing/fund-request/${temp.id}/send/`
      },

      handleSendBill(){
        this.form_send.validateFields(async(err,values)=>{
          if(!err){
            try{
              let intersection = this.contacts.filter(x => values.to_contacts.includes(x.id));
              const emails = intersection.map(item=> item.emails).flat()
              if(emails.length === 0){
                  this.$message.error('The following contact doesn\'t have any email address!')
                  return
              }
              this.$vs.loading()
              const {temp_row} = this
              await axios.post(this.sendReminderUrl(temp_row), {
                ...values,
                reference_code: temp_row.matters && temp_row.matters.length ? temp_row.matters[0].reference_code : undefined,
                tempType: localStorage.getItem('template_type')
              })
              this.$notification['success']({
                message: 'Success',
                description: `Send Email success.`,
              });
              this.form_send.resetFields()
              this.open_send_email = false
              this.billing_type = 'all'
              if(temp_row.is_send_bill){
                this.$refs.bill.query.query = []
                this.$refs.bill.fetch().then(()=>{})
              } else if(this.tab_bill !== '5'){
                this.$refs.ClientFund.query.query = []
                this.$refs.ClientFund.fetch().then(()=>{})
              }
            }catch (e) {
              this.$notification['error']({
                message: 'error',
                description: `Send Email failed.`,
              });
              this.open_send_email = true
            }finally {
              this.$vs.loading.close()
            }
          }
        })
      },

      handleEditBill(){
        this.form.validateFields(async(err,values)=>{
          if(!err){
            try{
              this.$vs.loading()
              values.time_entries    = this.temp_row.time_entries.length    ? this.temp_row.time_entries.map(item=> item.id)    : []
              values.expense_entries = this.temp_row.expense_entries.length ? this.temp_row.expense_entries.map(item=> item.id) : []
              values.matters = this.temp_row.matters.length ? this.temp_row.matters.map(item=>item.id) : []
              values.to_contact = this.temp_row.to_contact.id
              const {id} = this.temp_row
              await axios.put(`/billing/${id}/`,values)
              this.form.resetFields()
              this.open_edit_billing = false
              this.$notification['success']({
                message: 'Success',
                description: `Billing created`,
              });
              this.$refs.bill.fetch().then(()=>{})
            }catch (e) {
              this.$notification['error']({
                message: 'error',
                description: `Billing failed`,
              });
              this.open_edit_billing = true
            }finally {
              this.$vs.loading.close()
            }
          }
        })
      },

      async statusFilterBill() {
        if (this.$route.query){
          switch (this.$route.query.status) {
            case 'Unpaid':{
              this.tab_bill = '3'
              this.$refs.billUnpaid.query.query = [{field: "status", condition: "=", value: 3}]
              await this.$refs.billUnpaid.fetch()
              break
            }
            case 'Approved':{
              this.$refs.bill.query.query = [{field: "status", condition: "=", value: 2}]
              await this.$refs.bill.fetch()
              break
            }
            case 'Draft':{
              this.tab_bill = '2'
              this.$refs.billDraft.query.query = [{field: "status", condition: "=", value: 1}]
              await this.$refs.billDraft.fetch()
              break
            }
            case 'Today':{
              this.$refs.bill.query.query = [{field: "due_date", condition: "=", value: this.currentDateWithFormat}]
              await this.$refs.bill.fetch()
              break
            }
            case 'Overdue':{
              this.tab_bill = '4'
              this.$refs.billOverdue.query.query = [{field: "due_date", condition: "<", value: this.currentDateWithFormat}]
              await this.$refs.billOverdue.fetch()
              break
            }
          }
        }
      },

      handleReceipt() {
        this.formReceipt.validateFields(async (err, values) => {
          if (!err) {
            try{
              this.$vs.loading()
              if(this.edit_mode)
                await axios.put(`billing/official-receipt/${this.temp_row.id}/`,values)
              else
                await axios.post('billing/official-receipt',values)
              this.visibleReceipt = false
              this.hasReceiptClient = false
              this.formReceipt.resetFields()
              this.tab_bill = '5'
              this.$refs.billReceipt.fetch().catch(()=>{})
              this.$notification['success']({
                message: 'Success',
                description: 'Official receipt created successfully.',
              })
            }catch (e) {
              this.$message.error('Server Error ssss')
              throw new Error(e)
            }finally {
              this.$vs.loading.close()
            }
          }
        })
      },

      // async editActionReceipt(record) {
      //   await this.editReceipt(record)
      //   await this.handlerChangeReceipt(record.receive_from.id)
      // },

      async editReceipt(record) {
        try {
          this.visibleReceipt = true
          this.$vs.loading()
          this.temp_row = record
          this.edit_mode = true
          this.hasReceiptClient = true
          const {data} = await axios.get(`billing/official-receipt/${record.id}/`)
          await this.handlerChangeReceipt(data.receive_from.id)
          data.receive_from = data.receive_from.id
          data.payment_for  = data.payment_for.id
          this.$nextTick(() => {
            this.formReceipt.setFieldsValue(data)
          })
        }catch (e) {
          throw new Error(e)
        }finally {
          this.$vs.loading.close()
        }
      },

      newReceipt() {
        this.visibleReceipt = true;
        this.edit_mode = false;
        this.hasReceiptClient = false
        this.formReceipt.resetFields()
      },

      async sendToLhdn(record) {
        try {
          this.$vs.loading()
          const { data } = await axios.get(`billing/lhdn/${record.id}`)
          this.$notification['success']({
            message: 'Success',
            description: 'Your bill was submitted to LHDN. Check your LHDN panel to make sure there aren\'t any issues with the submitted invoice.',
          })
        } catch (e) {
          if (e.status === 422) {
            this.lhdnErrors = e.data.details
            this.$nextTick(() => {
              const errorsEl = document.getElementById('billing-error-messages')
              if (errorsEl) {
                errorsEl.scrollIntoView({ behavior: 'smooth', block: "start" })
              }
            })
          } else {
            this.$notification['error']({
              message: "Error",
              description: "Failed to submit the document to LHDN. This feature is fairly new and might not work correctly. Please contact support to resolve your problem.",
            })
            // this.$message.error(`${err.name}: ${err.msg}`)
          }
        } finally {
          this.$vs.loading.close()
        }
      }
    },

    computed: {
      currentDateFormat() {
        return moment().format('YYYY-MM-DD')
      },
      currencySymbol() {
        return localStorage.getItem('currency_symbol')
      },
    },

    created() {
      this.model = TableCol.default
      this.modelReceipt = TableColReceipt.default
    },

    async mounted() {
      this.is_click_add_time = true
      if (this.$route.params.query) {
        this.$refs.bill.onSearch(this.$route.params.query)
      }
      else {
        if (this.hasFilterContact)
          this.$refs.bill.query.query = [{ field: 'to_contact',condition:'=',value: this.$store.state.dashboard_contact_id || this.$route.params.id }]
        if (!this.$route.query.status)
          await this.$refs.bill.fetch()
      }
      await this.statusFilterBill()
      await this.getContacts()
    }
}
</script>

<style>
  @import "../style/style.css";
  .vs-tabs--ul{
    box-shadow: none !important;
  }
  [dir=ltr] .ant-tabs-content > [dir] .tab-sub.ant-tabs-tabpane > [dir] .ant-tabs-bar{
    border-bottom: none !important;
  }
  .billing .ant-modal-footer{
    display: none !important;
  }
  .ant-btn-group.ant-dropdown-button .ant-btn-primary{
    border-radius: 3px 0 0 3px !important;
  }
  .ant-btn-group .ant-btn-primary.ant-dropdown-trigger{
    border-radius: 0px 3px 3px 0px !important;
  }
  .ant-btn.ant-btn-link span{
    text-decoration: underline;
  }
  .ant-tag{
    border-radius: 3px !important;
  }
  .bnt-payment-bill {
    margin-left: auto;
    text-align: right;
    display: block;
    border-radius: 3px !important;
  }
  .description-receipt tr:nth-child(1) td, .description-receipt tr:nth-child(1) td span {
    font-weight: bold;
  }

  /*.header-modal-bill div[class="w-2/3"]{*/
  /*  border-top-left-radius : 6px;*/
  /*}*/
  /*.header-modal-bill div[class="w-1/3"]{*/
  /*  border-top-right-radius: 6px;*/
  /*}*/

</style>
